import React from "react";

const button = (props) => (
  <button
    type={props.buttonType}
    className={props.buttonClass}
    data-bs-dismiss={
      props.buttonDataDismiss ? props.buttonDataDismiss : undefined
    }
    data-toggle={props.buttonDataToggle}
    data-target={props.buttonDataTarget}
    aria-label={props.buttonAriaLabel}
    aria-expanded={props.buttonAriaExpanded ? "true" : "false"}
    data-action={props.buttonDataAction}
    style={props.buttonStyle}
  >
    {props.children}
  </button>
);

export default button;
